import React, { useState, useEffect } from 'react';
import { subscribeToPosts } from '../services/postService';
import Post from './Post';
import './PostList.css';

const PostList = ({ currentUser, selectedChannel }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!selectedChannel) {
      setPosts([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError('');

    const unsubscribe = subscribeToPosts((postsData) => {
      setPosts(postsData);
      setLoading(false);
    }, selectedChannel.id);

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [selectedChannel]);

  if (loading) {
    return (
      <div className="post-list-container">
        <div className="loading-posts">
          <div className="loading-spinner"></div>
          <p>Loading posts...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="post-list-container">
        <div className="error-message">
          {error}
        </div>
      </div>
    );
  }

  if (!selectedChannel) {
    return (
      <div className="post-list-container">
        <div className="no-posts">
          <h3>Select a channel</h3>
          <p>Choose a channel from the sidebar to view posts</p>
        </div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="post-list-container">
        <div className="no-posts">
          <h3>No posts yet in #{selectedChannel.name}</h3>
          <p>Be the first to share something in this channel!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="post-list-container">
      <div className="posts-header">
        <h2>Posts in #{selectedChannel.name}</h2>
        <p>{posts.length} post{posts.length !== 1 ? 's' : ''}</p>
      </div>
      
      <div className="posts-list">
        {posts.map((post) => (
          <Post 
            key={post.id} 
            post={post} 
            currentUser={currentUser}
          />
        ))}
      </div>
    </div>
  );
};

export default PostList;